export default "/static/c23c8eebb53d885c.svg"